module.exports = __webpack_public_path__ + "img/43.0923ab59.png";